var __jsx = React.createElement;
import React from 'react';
import Typography from '../../atoms/Typography';
import { FeeAmount, FeeContainer, FeeDetails, FeeDivider, FeeName } from './style';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OpportunityFee = function OpportunityFee(_ref) {
  var title = _ref.title,
    description = _ref.description,
    cost = _ref.cost,
    currency = _ref.currency;
  return cost > 0 && /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(FeeContainer, {
      children: [/*#__PURE__*/_jsxs(FeeDetails, {
        children: [/*#__PURE__*/_jsx(FeeName, {
          variant: "subtitle1",
          children: title
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          children: description
        })]
      }), /*#__PURE__*/_jsxs(FeeAmount, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h2",
          color: "primary",
          children: cost
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "body1",
          weight: "700",
          children: currency
        })]
      })]
    }), /*#__PURE__*/_jsx(FeeDivider, {})]
  });
};
export default OpportunityFee;